import React, {FC, useState} from 'react'
import {useForm, FormProvider} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {Panel, PanelGroup} from 'react-resizable-panels'
import {schemaParameter} from '../../../../../util/validation'
import {TabCentralModel} from '../../../../../models'
import {useCentral} from '../../../../../hooks/useCentral'
import ActionsContent from '../../componentes/Actions'
import ContainerWrapper from '../../componentes/Container'
import {ResizeHandle} from '../../../../hoteleria/components/Layout/Container/ResizeHandle/ResizeHandle'
import {renderPanelContent} from '../components'
import Swal from 'sweetalert2'
import {
  createParameterService,
  deleteParameterService,
  updateParameterService,
} from '../../../services/parameter.service'
import {UpdateParameterDto} from '../../../model/parameter.model'
import {ShowSnackBar} from '../../../../../util/functions'
const ParametersPageWrapper: FC = () => {
  const {currentTabItem, changeCurrentTabItem} = useCentral()
  const [loading, setLoading] = useState(false)

  const methods = useForm<UpdateParameterDto>({
    resolver: yupResolver(schemaParameter),
  })
  const {reset} = methods

  const handleDelete = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setLoading(true)
        let id = currentTabItem.idToDelete
        try {
          const data = await deleteParameterService(id)
          if (!data.data.error) {
            ShowSnackBar('Se eliminó con éxito')
            const obj: TabCentralModel = {
              ...currentTabItem,
              idToDelete: '',
              loadingTable: true,
            }
            changeCurrentTabItem(obj)
          } else {
            ShowSnackBar(data.data.message, 'error')
          }
          setLoading(false)
        } catch (error) {
          setLoading(false)
          //   ShowSnackBarNoExit('Error interno')
        }

        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const onSubmit = async (data: UpdateParameterDto) => {
    setLoading(true)
    try {
      if (currentTabItem.idToEdit) {
        data.Id = currentTabItem.idToEdit
        const lObj: TabCentralModel = {
          ...currentTabItem,
          loadingBottomPanelButton: true,
        }
        changeCurrentTabItem(lObj)
        const response = await updateParameterService(data)
        if (!response.data.error) {
          setLoading(false)
          ShowSnackBar('Se actualizó el registro correctamente')
          const obj: TabCentralModel = {
            ...currentTabItem,
            showPanel: false,
            idToEdit: '',
            loadingTable: true,
            loadingBottomPanelButton: false,
          }
          changeCurrentTabItem(obj)
        } else {
          setLoading(false)
          const obj: TabCentralModel = {
            ...currentTabItem,
            loadingBottomPanelButton: false,
          }
          changeCurrentTabItem(obj)
          ShowSnackBar(response.data.message, 'error')
        }
      } else {
        const response = await createParameterService(data)
        if (!response.data.error) {
          setLoading(false)
          reset()
          ShowSnackBar('Se creó con éxito')
          const obj: TabCentralModel = {
            ...currentTabItem,
            content: {
              ...currentTabItem.content,
              headerPanel: 'table-parameters',
            },
          }
          changeCurrentTabItem(obj)
        } else {
          setLoading(false)
          ShowSnackBar(response.data.message, 'error')
        }
      }
    } catch (error) {
      setLoading(false)
      const obj: TabCentralModel = {
        ...currentTabItem,
        loadingBottomPanelButton: false,
      }
      changeCurrentTabItem(obj)
      ShowSnackBar('Error interno', 'error')
    }
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <ActionsContent
          deleteClick={handleDelete}
          loading={loading}
          textComponentBack='table-parameters'
          textComponentGo='form-parameters'
        />
        <ContainerWrapper>
          <PanelGroup autoSaveId='example' direction='vertical' style={{height: '100%'}}>
            <Panel
              collapsible={true}
              order={1}
              key={`panel-central-header-${currentTabItem.id}`}
              id={`panel-central-header-${currentTabItem.id}`}
              className={'panel__box'}
            >
              {renderPanelContent(currentTabItem.content.headerPanel)}
            </Panel>
            <>
              {currentTabItem.showPanel && (
                <>
                  <ResizeHandle />
                  <Panel
                    className={'panel__box'}
                    collapsible={true}
                    defaultSize={50}
                    order={2}
                    key={`panel-central-detail-${currentTabItem.id}`}
                    id={`panel-central-detail-${currentTabItem.id}`}
                  >
                    {renderPanelContent(currentTabItem.content.detailPanel)}
                  </Panel>
                </>
              )}
            </>
          </PanelGroup>
        </ContainerWrapper>
      </form>
    </FormProvider>
  )
}

export default ParametersPageWrapper
